import { Component, OnInit, Input } from '@angular/core';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { PrivateLibraryPackageService } from 'src/app/core/services/private-library-package.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { PrivateLibraryService } from 'src/app/core/services/private-library.service';
import { environment } from 'src/environments/environment';
import { PlaylistService } from 'src/app/core/services/playlist.service';
import { LITERALS } from 'src/app/core/constants/literals.constant';
import { SuccessMessageComponent } from '../../all-modals/success-message/success-message.component';
import { ErrorMessageComponent } from '../../all-modals/error-message/error-message.component';
import { LocalStorageService } from 'src/app/core/services/local-storage.service';
import { LOCAL_STORAGE_CONSTANT } from 'src/app/core/services/local-storage.constant';


@Component({
  selector: 'app-create-package-modal',
  templateUrl: './create-package-modal.component.html',
  styleUrls: ['./create-package-modal.component.scss']
})
export class CreatePackageModalComponent implements OnInit {

  packageName: FormGroup;
  flagActive = 'audio';
  submitted: boolean = false;
  publication = [];
  searchText: string = '';
  music = [];
  video = [];
  packageArray = [];
  SelectedPackageArray = [];
  isError: boolean = false;
  isPackageError: boolean = false;
  errorMessage: string;
  packageMaterial = null;
  selectedPackage = [];
  imagePath: string;
  userData: any = {};
  @Input() public packageObj;
  @Input() public editPackage;
  @Input() public disableName;
  constructor(
    private activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private _privateLibraryService: PrivateLibraryService,
    private _spinner: NgxSpinnerService,
    private _playListService: PlaylistService,
    private modalService: NgbModal,
    private _privateLibraryPackageService: PrivateLibraryPackageService,
    private _localStorageService: LocalStorageService,
  ) { }

  ngOnInit() {
    this.imagePath = environment.url;
    this.packageName = this.formBuilder.group({
      package_name: ['', [Validators.required, Validators.pattern('^(?=.*?[a-zA-Z]).+$'), Validators.maxLength(30)]],
    })

    this.userData = this._localStorageService.getItem(LOCAL_STORAGE_CONSTANT.USER_DETAILS);

    if (this.packageObj && this.packageObj.name) {
      this.packageName.get('package_name').setValue(this.packageObj.name);
    }
    this.getContent();
  }

  getContent() {
    this._spinner.show();
    const obj = {
      category_type: 'created',
      library_type: 'public',
      create_package_flag: true
    }
    if (this.packageObj && this.packageObj.id && !this.editPackage) {
      obj['removable_collection_id'] = this.packageObj.id
    }
    this._privateLibraryService.getContent(obj).subscribe((response: any) => {
      if (response.success) {
        this.publication = response.data.document;
        this.music = response.data.music;
        this.video = response.data.video;
        this.packageArray = [...this.music, ...this.video, ...this.publication];

        if (this.editPackage) {
          this.getSelectedPackage();
        } else {
          this.packageArray.forEach(element => {
            element.isChecked = false;
          });
          this._spinner.hide();
        }
      }
      else {
        this._spinner.hide();
        this.errorMessage = response.message;
        this.isError = true;
      }
    }, (error: any) => {

      // this._toastr.warning(error);
      this._spinner.hide();
      this.errorMessage = error;
      this.isError = true;
    });
  }
  classActive(item) {
    this.flagActive = item;
    this.searchText = '';
  }

  closeDialog(data?) {
    this.activeModal.close(data);
  }

  createPackage() {
    this.submitted = true;
    if (!this.packageName.valid) {
      return;
    }
    let tokens = 0;

    this._spinner.show();
    const packageAttribute = [];
    this.SelectedPackageArray.forEach(element => {
      if (element.content_relationship) {
        tokens = tokens + element.tokens;
        packageAttribute.push({
          content_relationship_id: element.content_relationship.id
        });
      }
    })
    if (packageAttribute.length < 2 && !(this.packageObj && this.packageObj.id && !this.editPackage)) {
      this.isPackageError = true;
      this._spinner.hide();
      return;
    } else {
      this.isPackageError = false;
    }
    const obj = {
      content_collection: {
        name: this.packageName.get('package_name').value.trim(),
        tokens: tokens,
        collectables_attributes: packageAttribute,
        collection_type: "special"
      }
    }
// console.log(this.SelectedPackageArray);
// return;
    if (this.packageObj && this.packageObj.id && !this.editPackage) {
      this._playListService.addContentPlaylist(this.packageObj.id, obj).subscribe((response: any) => {
        this._spinner.hide();
        if (response.success) {
          this.closeDialog(response.data.content_collection);
          const modelRef = this.modalService.open(SuccessMessageComponent, { centered: true });
          modelRef.componentInstance.message = LITERALS.AUTH.SUCCESS_MESSAGES.PACKAGE_UPDATED_SUCCESS;
        } else {
          this.errorMessage = response.message;
          this.isError = true;
        }
      }, (error: any) => {
        const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
        modalRef.componentInstance.message = error;
        // this._toastr.warning(error);
        this._spinner.hide();
        this.errorMessage = error;
        this.isError = true;
      })
    } else if (this.packageObj && this.packageObj.id && this.editPackage) {
      this._privateLibraryPackageService.editPackage(this.packageObj.id, obj).subscribe((response: any) => {
        this._spinner.hide();
        if (response.success) {
          this.closeDialog(response.data.content_collection);
          const modelRef = this.modalService.open(SuccessMessageComponent, { centered: true });
          modelRef.componentInstance.message = LITERALS.AUTH.SUCCESS_MESSAGES.PACKAGE_UPDATED_SUCCESS;
        } else {
          this.errorMessage = response.message;
          this.isError = true;
        }
      }, (error: any) => {
        const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
        modalRef.componentInstance.message = error;
        // this._toastr.warning(error);
        this._spinner.hide();
        this.errorMessage = error;
        this.isError = true;
      });
    } else {
      this._privateLibraryPackageService.createPackage(obj).subscribe((response: any) => {
        this._spinner.hide();
        if (response.success) {
          this.closeDialog(response.data.content_collection);
          const modelRef = this.modalService.open(SuccessMessageComponent, { centered: true });
          modelRef.componentInstance.message = LITERALS.AUTH.SUCCESS_MESSAGES.PACKAGE_CREATED_SUCCESS;
        } else {
          this.errorMessage = response.message;
          this.isError = true;
        }
      }, (error: any) => {
        const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
        modalRef.componentInstance.message = error;
        // this._toastr.warning(error);
        this._spinner.hide();
        this.errorMessage = error;
        this.isError = true;
      });
    }
  }

  toggleCheckBox(data) {
    data.isChecked = !data.isChecked;
    if (data.isChecked) {
      this.SelectedPackageArray.push(data);
    } else {
      const index = this.SelectedPackageArray.findIndex(s => s.id === data.id);
      if (index > -1) {
        this.SelectedPackageArray.splice(index, 1);
      }
    }
    this.isPackageError = false;
  }

  getCheckedLength(value) {
    switch (value) {
      case 'audio':
        const musicSelectArray = this.music.filter(val => {
          return val.isChecked
        })
        return musicSelectArray.length;
      case 'video':
        const videoSelectArray = this.video.filter(val => {
          return val.isChecked
        })
        return videoSelectArray.length;
      case 'publication':
        const publicationSelectArray = this.publication.filter(val => {
          return val.isChecked
        })
        return publicationSelectArray.length;
    }
  }
  getCheckedLengthTotal() {

    const musicSelectArray = this.music.filter(val => {
      return val.isChecked
    })

    const videoSelectArray = this.video.filter(val => {
      return val.isChecked
    })

    const publicationSelectArray = this.publication.filter(val => {
      return val.isChecked
    })
    return musicSelectArray.length + videoSelectArray.length + publicationSelectArray.length;
  }

  getSelectedPackage() {
    this._privateLibraryService.showPackage(this.packageObj.id).subscribe((response: any) => {
      if (response.success) {
        if (response.data.audio_contents) {
          this.selectedPackage = response.data.audio_contents;
        }
        if (response.data.video_contents) {
          this.selectedPackage = response.data.video_contents;
        }
        if (response.data.document_contents) {
          this.selectedPackage = response.data.document_contents;
        }
        if (response.data.content_collection && response.data.content_collection.contents.length) {
          this.selectedPackage = response.data.content_collection.contents;
        }
        if (this.selectedPackage && this.selectedPackage.length) {
          this.SelectedPackageArray = this.selectedPackage;
          this.selectedPackage.map(audio_contents => {
            let default_icon = '';
            if (audio_contents.content_type === 'audio') {
              default_icon = '../../assets/images/icons/audio-primary-default-card-icon.jpg';
            } else if (audio_contents.content_type === 'video') {
              default_icon = '../../assets/images/icons/video-primary-default-card-icon.jpg';
            } else if (audio_contents.content_type === 'document') {
              default_icon = '../../assets/images/icons/publication-primary-default-card-icon.jpg';
            }
            audio_contents.thumb = (audio_contents.thumb != '') ? this.imagePath + audio_contents.thumb : default_icon;
          });
        }
        this.selectContent();
      }
      else {
        this._spinner.hide();
        // this.errorMessage = LITERALS.AUTH.ERROR_MESSAGES.SOMETHING_WENT_WRONG;
        this.isError = true;
      }
    }, (error: any) => {

      // this._toastr.warning(LITERALS.AUTH.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
      this._spinner.hide();
      this.errorMessage = error;
      this.isError = true;
    })
  }
  selectContent() {
    this.packageArray.forEach(element => {
      if (this.selectedPackage.find(ele => { return ele.id === element.id })) {
        element.isChecked = true;
      } else {
        element.isChecked = false;
      }
    });
    this._spinner.hide();
  }

  trimControl(control) {
    if (this.packageName.get(control).value) {
      this.packageName.get(control).setValue(this.packageName.get(control).value.trim())
    }
  }
}
